module.exports = __webpack_public_path__ + "static/media/taabi_logo.ae881c72.png";